export default {"src":"/_next/static/media/ads.6cd8899a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};